import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Message } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { ModalTemplate, Button, ReduxFormMaterialTextField, ReduxFormHiddenInput } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalLeaveService extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null
    };
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isClicked, leaveServiceData } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-serviceLeave-area', 'common-content')}
        visible
        onToggleModal={leaveServiceData.onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalLeaveService_1', defaultMessage: '탈퇴 하기' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                leaveServiceData.onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalLeaveService_3', defaultMessage: '취 소' }))}
            </Button>
            <Button
              className={cx('gray-button')}
              disabled={isClicked}
              loading={isClicked}
              onClick={leaveServiceData.onLeaveService}>
              {defineMessages(formatMessage({ id: 'ModalLeaveService_2', defaultMessage: '탈 퇴' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <div className={cx('message-header')}>
            {defineMessages(formatMessage({ id: 'ModalLeaveService_4', defaultMessage: '정말 탈퇴 하시겠습니까?' }))}
          </div>
          <Message className={cx('template-detail-box')}>
            <div className={cx('template-detail')}>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'ModalLeaveService_5', defaultMessage: '비밀번호' }))}
              </span>
              <ReduxFormMaterialTextField
                className={cx('input-area')}
                // label={defineMessages(formatMessage({ id: 'ModalLeaveService_5', defaultMessage: '비밀번호' }))}
                type="password"
                fullWidth
                validate={['required']}
                name="userPassword"
                checkType={101}
                error={leaveServiceData.errorMessage.type === 'userPassword' ? true : false}
                errorText={
                  leaveServiceData.errorMessage.type === 'userPassword' && leaveServiceData.errorMessage.content
                }
                // helperText={
                //   leaveServiceData.errorMessage.type === 'userPassword' && leaveServiceData.errorMessage.content
                // }
              />
              <ReduxFormHiddenInput name="userNo" />
            </div>
          </Message>
        </div>
      </ModalTemplate>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      userNo: props.userNo
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formLeaveService',
    enableReinitialize: true
  })(injectIntl(ModalLeaveService))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalLeaveService.js